export const browserLocale = navigator.language;